import { Routes } from '@angular/router';
import { ReferralsGuard } from '../../../app/referrals-guard.guard';
import { withTranslations } from '../i18n/resolvers/translations.resolvers';
import {
    LOCALE_POLICY_DATA_KEY,
    LocaleResolutionPolicy,
} from '@app/common/locale/domain/entities/locale-resolution-policy';
import { Section } from 'common/data/i18n/services/angular-i18n.service';
import { validCobrarActionCanMatch } from './guards/public-route-validation.guards';
import { ClientChannel } from '@app/common/headers/domain/client-channel';
import { withClientChannel } from '../headers/application/client-channel-route-data';

// /t y /u: el idioma lo decide solo la URL (es/en sin region). Se mergea con el data de
// withTranslations para que el spread no pise la politica.
function withUrlOnlyTranslations(...sections: Array<Section>): ReturnType<typeof withTranslations> {
    const translations: ReturnType<typeof withTranslations> = withTranslations(...sections);

    return {
        ...translations,
        data: { ...translations.data, [LOCALE_POLICY_DATA_KEY]: LocaleResolutionPolicy.UrlOnly },
    };
}

export const transactionsRoutes: Routes = [
    {
        path: 'cobrar',
        loadChildren: () =>
            import('../../../app/transactions/pages/exchange/exchange.module').then(
                (m) => m.ExchangeModule,
            ),
        canMatch: [validCobrarActionCanMatch],
        canActivate: [ReferralsGuard],
        ...withTranslations(
            'exchange',
            'dashboard',
            'ui',
            'landing',
            'orders',
            'vcc',
            'transactions',
        ),
    },
    {
        path: 't/transactions/v3',
        loadChildren: () =>
            import('../../pages/transaction-details/transaction-details.module').then(
                (m) => m.TransactionDetailsModule,
            ),
        canActivate: [ReferralsGuard],
        ...withUrlOnlyTranslations(
            'transactions',
            'help-and-terms',
            'direct-transfer',
            'dashboard',
        ),
    },
    {
        path: 't/transactions',
        loadChildren: () =>
            import('../../../app/transactions/pages/transaction-info/transaction-info.module').then(
                (m) => m.TransactionInfoModule,
            ),
        canActivate: [ReferralsGuard],
        ...withUrlOnlyTranslations(
            'transactions',
            'dashboard',
            'ui',
            'canceled-order',
            'vcc',
            'transaction-states',
            'orders',
            'direct-transfer',
        ),
    },
    {
        path: 'comprar-vcc',
        loadChildren: () =>
            import('../../../app/transactions/pages/transaction-vcc/transaction-vcc.module').then(
                (m) => m.TransactionVccModule,
            ),
        canActivate: [ReferralsGuard],
        ...withClientChannel(
            withTranslations('vcc', 'dashboard', 'orders', 'landing'),
            ClientChannel.Vcc,
        ),
    },
    {
        path: 'u',
        loadChildren: () =>
            import('../../../app/transactions/pages/user-info/user-info.module').then(
                (m) => m.UserInfoModule,
            ),
        canActivate: [ReferralsGuard],
        ...withUrlOnlyTranslations('validations', 'transactions', 'header'),
    },
    {
        path: 'transaction-states',
        loadChildren: () =>
            import('../../../app/transactions/pages/transaction-states/transaction-states.module').then(
                (m) => m.TransactionStatesModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('transaction-states', 'ui'),
    },
    {
        path: 'transaction-states/:token',
        loadChildren: () =>
            import('../../../app/transactions/pages/transaction-states/transaction-states.module').then(
                (m) => m.TransactionStatesModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('transaction-states', 'ui'),
    },
];

export const localeTransactionsRoutes: Routes = transactionsRoutes.filter(
    (route) => route.path !== 'transaction-states/:token',
);
